import { CommandContribution } from '@patsnap/tahiti-core/common/command';
import { ShareSpaceActionContribution } from './share-space-action-contribution';
import { SpaceActionContribution } from '@/services/space-action-contribution';
import { ShareSpaceServiceImpl } from './share-space-service';
import { ShareSpaceService } from './share-space-service.interface';
import { ShareSpaceDialogService } from './share-space-dialog-service.interface';
import { createShareSpaceDialog } from './share-space-dialog-service';
import { ShareSpaceCommandContribution } from './share-space-command-contribution';
import { SharePublicSpaceActionContribution } from './share-public-space-action-contribution';
import { SharePublicSpaceCommandContribution } from './share-public-space-command-contribution';
export function shareSpaceModule(bind) {
    bind(ShareSpaceService).to(ShareSpaceServiceImpl);
    bind(CommandContribution).to(ShareSpaceCommandContribution);
    bind(SpaceActionContribution).to(ShareSpaceActionContribution);
    bind(CommandContribution).to(SharePublicSpaceCommandContribution);
    bind(SpaceActionContribution).to(SharePublicSpaceActionContribution);
    bind(ShareSpaceDialogService).toDynamicValue(createShareSpaceDialog());
}
